import { Box, Typography } from '@material-ui/core'
import React from 'react'

import { SKIP_SHOW_PRESENTATION } from 'constants.js'
import clsx from 'clsx'
import { shouldShowAuthError } from 'redux/slices/authentication'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import { Show } from 'data/Show'
import Loader from './Loader'

interface AnimatedSetPageLoadingProps {
    show: Show
    isLoading: boolean
}

export const AnimatedSetPageLoading: React.FC<AnimatedSetPageLoadingProps> = ({ show, isLoading }) => {
    const classes = useStyles()
    const authError = useSelector(shouldShowAuthError)
    const skipPresentation = SKIP_SHOW_PRESENTATION || authError

    return isLoading ? (
        <Loader isLoading={isLoading} />
    ) : !skipPresentation ? (
        <Box className={clsx(classes.background, classes.loaded)}>
            <Box className={classes.content}>
                <Box className={classes.photoWrapper}>
                    <Box className={classes.photo} style={{ backgroundImage: `url(${show.posterImg})` }} />
                </Box>

                <Box className={classes.boxWrapper}>
                    <Typography className={classes.title}>{show.title}</Typography>
                </Box>

                <Box className={classes.boxWrapper}>
                    <Typography className={classes.presentedBy}>Joining the Event</Typography>
                </Box>
            </Box>
        </Box>
    ) : null
}

export default React.memo(AnimatedSetPageLoading)
